declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string
        initDataUnsafe: {
          user?: {
            id: number
            first_name: string
            last_name?: string
            username?: string
            photo_url?: string
            language_code?: string
          }
          start_param?: string
        }
        themeParams: {
          bg_color?: string
          text_color?: string
          hint_color?: string
          link_color?: string
          button_color?: string
          button_text_color?: string
          secondary_bg_color?: string
          header_bg_color?: string
          accent_text_color?: string
          section_bg_color?: string
          section_header_text_color?: string
          subtitle_text_color?: string
          destructive_text_color?: string
        }
        colorScheme: "light" | "dark"
        expand: () => void
        close: () => void
        ready: () => void
        BackButton: {
          show: () => void
          hide: () => void
          onClick: (cb: () => void) => void
          offClick: (cb: () => void) => void
        }
        MainButton: {
          text: string
          show: () => void
          hide: () => void
          enable: () => void
          disable: () => void
          onClick: (cb: () => void) => void
          offClick: (cb: () => void) => void
          setParams: (params: {
            text?: string
            color?: string
            text_color?: string
            is_active?: boolean
            is_visible?: boolean
          }) => void
        }
        HapticFeedback: {
          impactOccurred: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => void
          notificationOccurred: (type: "error" | "success" | "warning") => void
          selectionChanged: () => void
        }
        openLink: (url: string) => void
        openTelegramLink: (url: string) => void
        showAlert: (message: string, callback?: () => void) => void
        showConfirm: (message: string, callback?: (ok: boolean) => void) => void
        shareToStory: (mediaUrl: string, params?: { widget_link?: { url: string; name?: string } }) => void
        isExpanded: boolean
        viewportHeight: number
        viewportStableHeight: number
      }
    }
  }
}

export function getTelegramWebApp() {
  return window.Telegram?.WebApp ?? null
}

export function isTelegramMiniApp(): boolean {
  return !!window.Telegram?.WebApp?.initData
}

export function getTelegramThemeVars(): Record<string, string> {
  const tp = window.Telegram?.WebApp?.themeParams
  if (!tp) return {}

  const vars: Record<string, string> = {}
  if (tp.bg_color) vars["--tg-bg"] = tp.bg_color
  if (tp.text_color) vars["--tg-text"] = tp.text_color
  if (tp.hint_color) vars["--tg-hint"] = tp.hint_color
  if (tp.link_color) vars["--tg-link"] = tp.link_color
  if (tp.button_color) vars["--tg-button"] = tp.button_color
  if (tp.button_text_color) vars["--tg-button-text"] = tp.button_text_color
  if (tp.secondary_bg_color) vars["--tg-secondary-bg"] = tp.secondary_bg_color
  if (tp.header_bg_color) vars["--tg-header-bg"] = tp.header_bg_color
  if (tp.accent_text_color) vars["--tg-accent"] = tp.accent_text_color
  if (tp.section_bg_color) vars["--tg-section-bg"] = tp.section_bg_color
  if (tp.section_header_text_color) vars["--tg-section-header"] = tp.section_header_text_color
  if (tp.subtitle_text_color) vars["--tg-subtitle"] = tp.subtitle_text_color
  if (tp.destructive_text_color) vars["--tg-destructive"] = tp.destructive_text_color
  return vars
}
